export const ArrowDownIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2.25C9.41422 2.25 9.75 2.58579 9.75 3V13.1895L12.2197 10.7197C12.5126 10.4269 12.9874 10.4269 13.2803 10.7197C13.5732 11.0126 13.5732 11.4874 13.2803 11.7803L9.53418 15.5264C9.52095 15.5398 9.50737 15.553 9.49317 15.5654C9.46402 15.5909 9.43321 15.6136 9.40137 15.6338L9 15.75C8.98657 15.75 8.97322 15.7497 8.95996 15.749C8.87778 15.7447 8.79866 15.727 8.72559 15.6982C8.63237 15.6617 8.54507 15.6056 8.46973 15.5303L4.71973 11.7803C4.42684 11.4874 4.42684 11.0126 4.71973 10.7197C5.01262 10.4268 5.48738 10.4268 5.78028 10.7197L8.25 13.1895V3C8.25 2.58579 8.58579 2.25 9 2.25Z"
      fill="currentColor"
    />
  </svg>
);
